import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import { getBlockEntityType, KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { BaseToolbarButton } from '../baseToolbarButton.js';
import { BUTTONS_BY_KEY, deleteButton } from '../buttons/index.js';
import { Separator, Panel } from 'wix-rich-content-ui-components';
import { t as toolbarStyles, T as ToolbarContent } from '../../ToolbarContent-e2158c37.js';
import { isSSR, TABLE_TYPE } from 'wix-rich-content-common';
import { getRelativePositionStyle, getToolbarPosition, setVariables } from './toolbarUtils.js';
import { BUTTONS } from '../buttons/keys.js';
import BlockLinkButton from '../buttons/BlockLinkButton.js';
import BlockSpoilerButton from '../buttons/BlockSpoilerButton.js';
import '../buttons/createBlockButton.js';
import '../buttons/createBlockAlignmentButton.js';
import '../buttons/createBlockAlignmentAndSizeButton.js';
import '../buttons/createBlockSizeButton.js';
import '../buttons/createSliderPanelButton.js';
import '../../Icons/SizeSmallIcon.js';
import '../../Icons/SizeMediumIcon.js';
import '../../Icons/SizeLargeIcon.js';
import '../../Icons/SizeOriginalIcon.js';
import '../../Icons/AlignCenterIcon.js';
import '../../Icons/SizeSmallCenterIcon.js';
import '../../Icons/SizeSmallLeftIcon.js';
import '../../Icons/SizeSmallRightIcon.js';
import '../../Icons/SizeBestFitIcon.js';
import '../../Icons/SizeFullWidthIcon.js';
import '../../Icons/TrashIcon.js';
import '../../Icons/WidthIcon.js';
import '../../Icons/HeightIcon.js';
import 'lodash';
import '../../Icons/SpoilerButtonIcon.js';
import 'react-measure';
import '../../style-inject.es-746bb8ed.js';
import '../../consts.js';
import '../default-toolbar-settings.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function createAtomicPluginToolbar({
  buttons,
  theme,
  pubsub,
  helpers,
  settings,
  isMobile,
  anchorTarget,
  relValue,
  t,
  name,
  uiSettings,
  getToolbarSettings,
  getEditorBounds,
  getEditorState,
  linkTypes,
  innerModal,
  innerRCERenderedIn
}) {
  var _a;
  return _a = class extends Component {
    constructor(props) {
      super(props);
      __publicField(this, "onOverrideContent", (overrideContent) => {
        this.setState({ overrideContent });
      });
      __publicField(this, "onComponentStateChanged", (contentState) => {
        this.setState({ contentState });
      });
      __publicField(this, "onComponentDataChanged", (componentData) => {
        this.setState({ componentData }, () => this.onVisibilityChanged(pubsub.get("focusedBlock")));
      });
      __publicField(this, "onComponentLinkChange", (linkData) => {
        if (!linkData) {
          this.updateLinkData(null);
          return;
        }
        const { url, anchor, target, rel } = linkData;
        const link = url ? {
          url,
          target,
          rel
        } : { anchor };
        this.updateLinkData(link);
      });
      __publicField(this, "updateLinkData", (link) => {
        pubsub.update("componentData", { config: null });
        pubsub.update("componentData", { config: { link } });
      });
      __publicField(this, "setLayoutProps", ({ alignment, size, textWrap }) => {
        pubsub.update("componentData", { config: { alignment, size, textWrap } });
      });
      __publicField(this, "onVisibilityChanged", (focusedBlock) => {
        if (!this.shouldCreate) {
          return;
        }
        if (focusedBlock && !isSSR() && window.getSelection().isCollapsed) {
          this.showToolbar();
        } else {
          this.hideToolbar();
        }
        if (focusedBlock !== this.focusedBlock) {
          this.hidePanels();
        }
        this.focusedBlock = focusedBlock;
      });
      __publicField(this, "hideToolbar", () => {
        this.setState({
          position: { transform: "scale(0)" },
          componentData: {},
          componentState: {},
          overrideContent: void 0,
          tabIndex: -1,
          isVisible: false
        });
      });
      __publicField(this, "getRelativePositionStyle", (boundingRect) => {
        const { position, updatedOffsetHeight } = getRelativePositionStyle({
          boundingRect,
          offset: this.offset,
          offsetHeight: this.offsetHeight,
          toolbarNode: findDOMNode(this),
          isMobile,
          renderedInTable: innerRCERenderedIn === TABLE_TYPE
        });
        this.offsetHeight = updatedOffsetHeight;
        return position;
      });
      __publicField(this, "showToolbar", () => {
        const boundingRect = pubsub.get("boundingRect");
        if (this.visibilityFn() && boundingRect && boundingRect.width !== 0) {
          this.setState({ isVisible: true }, () => {
            const componentData = pubsub.get("componentData") || {};
            const componentState = pubsub.get("componentState") || {};
            const position = getToolbarPosition({
              boundingRect,
              displayOptions: this.displayOptions,
              getRelativePositionStyle: this.getRelativePositionStyle,
              offset: this.offset
            });
            this.setState({
              tabIndex: 0,
              componentData,
              componentState,
              position
            });
          });
        }
      });
      /*eslint-disable complexity*/
      __publicField(this, "PluginToolbarButton", ({
        button,
        index,
        themedStyle,
        separatorClassNames,
        tabIndex,
        componentData
      }) => {
        var _a2, _b, _c, _d;
        const { alignment, size } = componentData;
        const icons = ((_a2 = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a2.icons) || {};
        const buttonByKey = BUTTONS_BY_KEY[button.type];
        const Button = buttonByKey && buttonByKey(icons[button.keyName]) || BaseToolbarButton;
        const commonButtonProps = {
          tabIndex,
          theme: themedStyle,
          key: index,
          isMobile,
          t,
          pubsub,
          helpers,
          keyName: button.keyName,
          beforeOnClickDelete: button == null ? void 0 : button.beforeOnClickDelete
        };
        const editorState = getEditorState();
        const pluginType = editorState && this.focusedBlock && getBlockEntityType(editorState, this.focusedBlock);
        const buttonProps = __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, this.mapComponentDataToButtonProps(button, this.state.componentData)), this.mapStoreDataToButtonProps(button, pubsub.store, this.state.componentData)), {
          settings: button.settings,
          pluginType
        }), commonButtonProps);
        const baseLinkProps = __spreadValues({
          onOverrideContent: this.onOverrideContent,
          helpers,
          componentState: this.state.componentState,
          closeModal: helpers.closeModal,
          anchorTarget,
          relValue,
          uiSettings,
          icons: icons.link,
          editorState,
          linkTypes,
          toolbarOffsetTop: this.state.position && this.state.position["--offset-top"],
          toolbarOffsetLeft: this.state.position && this.state.position["--offset-left"],
          innerModal,
          pluginType
        }, commonButtonProps);
        const defaultButtonProps = __spreadValues({
          componentData: this.state.componentData,
          componentState: this.state.componentState,
          helpers,
          displayPanel: this.displayPanel,
          displayInlinePanel: this.displayInlinePanel,
          hideInlinePanel: this.hidePanels,
          uiSettings,
          getEditorBounds,
          blockKey: this.focusedBlock
        }, buttonProps);
        switch (button.type) {
          case BUTTONS.TEXT_ALIGN_LEFT:
          case BUTTONS.TEXT_ALIGN_CENTER:
          case BUTTONS.TEXT_ALIGN_RIGHT:
            return /* @__PURE__ */ React.createElement(Button, __spreadValues({ alignment, setLayoutProps: this.setLayoutProps }, buttonProps));
          case BUTTONS.SIZE_SMALL:
          case BUTTONS.SIZE_MEDIUM:
          case BUTTONS.SIZE_LARGE:
            return /* @__PURE__ */ React.createElement(Button, __spreadValues({ size, setLayoutProps: this.setLayoutProps }, buttonProps));
          case BUTTONS.SIZE_ORIGINAL:
          case BUTTONS.SIZE_CONTENT:
          case BUTTONS.SIZE_FULL_WIDTH:
          case BUTTONS.SIZE_CONTENT_CENTER:
          case BUTTONS.SIZE_SMALL_CENTER:
          case BUTTONS.SIZE_SMALL_LEFT:
          case BUTTONS.SIZE_SMALL_RIGHT:
          case BUTTONS.ALIGN_RIGHT:
          case BUTTONS.ALIGN_LEFT:
          case BUTTONS.ALIGN_CENTER:
            return /* @__PURE__ */ React.createElement(
              Button,
              __spreadValues({
                size,
                alignment,
                setLayoutProps: this.setLayoutProps
              }, buttonProps)
            );
          case BUTTONS.SEPARATOR:
            return /* @__PURE__ */ React.createElement(Separator, { className: separatorClassNames, key: index });
          case BUTTONS.HORIZONTAL_SEPARATOR:
            return /* @__PURE__ */ React.createElement(Separator, { className: separatorClassNames, horizontal: true, key: index });
          case BUTTONS.LINK:
            return /* @__PURE__ */ React.createElement(BlockLinkButton, __spreadProps(__spreadValues({}, baseLinkProps), { tooltipText: t("TextLinkButton_Tooltip") }));
          case BUTTONS.SPOILER:
            return /* @__PURE__ */ React.createElement(BlockSpoilerButton, __spreadProps(__spreadValues({}, commonButtonProps), { tooltipText: t("Spoiler_Insert_Tooltip") }));
          case BUTTONS.VIDEO_SETTINGS: {
            const isCustomVideo = this.state.componentData.isCustomVideo;
            const shouldShowSettingsButton = button.settings.spoiler || isCustomVideo;
            const videoSettingsProps = __spreadProps(__spreadValues({}, defaultButtonProps), {
              type: BUTTONS.EXTERNAL_MODAL
            });
            return shouldShowSettingsButton ? /* @__PURE__ */ React.createElement(Button, __spreadValues({}, videoSettingsProps)) : null;
          }
          case BUTTONS.FILE_UPLOAD_SETTINGS: {
            const shouldShowSettingsButton = this.state.componentData.type === "pdf" && !innerRCERenderedIn;
            const fileUploadSettingsProps = __spreadProps(__spreadValues({}, defaultButtonProps), {
              type: BUTTONS.EXTERNAL_MODAL
            });
            return shouldShowSettingsButton ? /* @__PURE__ */ React.createElement(Button, __spreadValues({}, fileUploadSettingsProps)) : null;
          }
          case BUTTONS.AUDIO_SETTINGS: {
            const shouldShowSettingsButton = !!((_d = (_c = (_b = this.state.componentData) == null ? void 0 : _b.audio) == null ? void 0 : _c.src) == null ? void 0 : _d.id);
            const audioSettingsProps = __spreadProps(__spreadValues({}, defaultButtonProps), {
              type: BUTTONS.EXTERNAL_MODAL
            });
            return shouldShowSettingsButton ? /* @__PURE__ */ React.createElement(Button, __spreadValues({}, audioSettingsProps)) : null;
          }
          case BUTTONS.LINK_PREVIEW: {
            return !this.state.componentData.html && /* @__PURE__ */ React.createElement(
              BlockLinkButton,
              __spreadProps(__spreadValues({}, baseLinkProps), {
                hideUrlInput: true,
                tooltipText: t("LinkPreview_Settings_Tooltip"),
                icons: button.icons
              })
            );
          }
          case BUTTONS.DELETE: {
            const DeleteButtonComponent = deleteButton(icons.delete);
            return /* @__PURE__ */ React.createElement(
              DeleteButtonComponent,
              __spreadValues({
                onClick: () => {
                  var _a3;
                  (_a3 = buttonProps == null ? void 0 : buttonProps.beforeOnClickDelete) == null ? void 0 : _a3.call(buttonProps);
                  pubsub.get("deleteBlock")();
                },
                icon: icons.delete
              }, buttonProps)
            );
          }
          default:
            return /* @__PURE__ */ React.createElement(Button, __spreadValues({}, defaultButtonProps));
        }
      });
      /*eslint-enable complexity*/
      __publicField(this, "mapComponentDataToButtonProps", (button, componentData) => {
        if (!button.mapComponentDataToButtonProps) {
          return button;
        }
        return __spreadValues(__spreadValues({}, button), button.mapComponentDataToButtonProps(componentData));
      });
      __publicField(this, "mapStoreDataToButtonProps", (button, store, componentData) => {
        if (!button.mapStoreDataToButtonProps) {
          return button;
        }
        return __spreadValues(__spreadValues({}, button), button.mapStoreDataToButtonProps({ store, componentData }));
      });
      __publicField(this, "hidePanels", () => this.setState({ panel: null, inlinePanel: null }));
      __publicField(this, "displayPanel", (panel) => {
        this.hidePanels();
        this.setState({ panel });
      });
      __publicField(this, "displayInlinePanel", (inlinePanel) => {
        this.hidePanels();
        this.setState({ inlinePanel });
      });
      __publicField(this, "onKeyDown", (e) => {
        var _a2, _b;
        if (e.keyCode === KEYS_CHARCODE.ESCAPE) {
          (_b = (_a2 = this.props).removeToolbarFocus) == null ? void 0 : _b.call(_a2);
        }
      });
      __publicField(this, "onClick", (e) => {
        e.preventDefault();
      });
      const { structure, offset, shouldCreate, visibilityFn, displayOptions, ToolbarDecoration } = setVariables({ buttons, getToolbarSettings, isMobile });
      this.structure = structure;
      this.offset = offset;
      this.shouldCreate = shouldCreate;
      this.visibilityFn = visibilityFn;
      this.displayOptions = displayOptions;
      this.ToolbarDecoration = ToolbarDecoration;
      this.state = {
        position: { transform: "scale(0)" },
        componentData: {},
        componentState: {},
        overrideContent: void 0,
        tabIndex: -1
      };
    }
    componentDidMount() {
      pubsub.subscribe("focusedBlock", this.onVisibilityChanged);
      pubsub.subscribe("componentState", this.onComponentStateChanged);
      pubsub.subscribe("componentData", this.onComponentDataChanged);
      this.unsubscribeOnBlock = pubsub.subscribeOnBlock({
        key: "componentLink",
        callback: this.onComponentLinkChange
      });
      const focusedBlock = pubsub.get("focusedBlock");
      this.onVisibilityChanged(focusedBlock);
    }
    componentWillUnmount() {
      pubsub.unsubscribe("focusedBlock", this.onVisibilityChanged);
      pubsub.unsubscribe("componentState", this.onComponentStateChanged);
      pubsub.unsubscribe("componentData", this.onComponentDataChanged);
      this.unsubscribeOnBlock && this.unsubscribeOnBlock();
    }
    shouldComponentUpdate(_nextProps, nextState) {
      return !!(this.state.isVisible || nextState.isVisible);
    }
    renderInlinePanel() {
      const { inlinePanel, componentData, componentState } = this.state;
      const { PanelContent, keyName } = inlinePanel || {};
      return inlinePanel ? /* @__PURE__ */ React.createElement(
        "div",
        {
          className: toolbarStyles.pluginToolbar_inlinePanel,
          "data-hook": "baseToolbar_InlinePanel"
        },
        /* @__PURE__ */ React.createElement(
          PanelContent,
          {
            key: keyName,
            theme,
            store: pubsub,
            helpers,
            t,
            componentData,
            componentState,
            close: this.hidePanels
          }
        )
      ) : null;
    }
    renderPanel() {
      const { panel, componentData, componentState } = this.state;
      return panel ? /* @__PURE__ */ React.createElement("div", { className: toolbarStyles.pluginToolbar_panel }, /* @__PURE__ */ React.createElement(
        Panel,
        {
          key: panel.keyName,
          theme,
          store: pubsub,
          helpers,
          t,
          componentData,
          componentState,
          content: panel.PanelContent,
          keyName: panel.keyName,
          close: this.hidePanels,
          getEditorBounds
        }
      )) : null;
    }
    render() {
      const { overrideContent, tabIndex, isVisible } = this.state;
      const { hide } = this.props;
      const triggerOnLoadBi = () => {
        var _a2;
        (_a2 = helpers == null ? void 0 : helpers.onInlineToolbarOpen) == null ? void 0 : _a2.call(helpers, {
          toolbarType: "PLUGIN",
          pluginId: this.focusedBlock && getBlockEntityType(getEditorState(), this.focusedBlock)
        });
      };
      const toolbarContentProps = {
        overrideContent,
        tabIndex,
        theme,
        triggerOnLoadBi,
        PluginToolbarButton: this.PluginToolbarButton,
        structure: this.structure,
        componentData: this.state.componentData.config || {}
      };
      if (!this.shouldCreate) {
        return null;
      }
      const { toolbarStyles: toolbarTheme } = theme || {};
      if (this.visibilityFn() && isVisible) {
        const renderedInTable = innerRCERenderedIn === TABLE_TYPE;
        const props = {
          style: __spreadProps(__spreadValues({}, this.state.position), {
            visibility: hide ? "hidden" : "visible",
            left: "var(--offset-left)",
            right: "unset"
          }),
          className: classNames(
            toolbarStyles.pluginToolbar,
            renderedInTable && toolbarStyles.overflowToolbar,
            toolbarTheme && toolbarTheme.pluginToolbar
          ),
          "data-hook": name ? `${name}PluginToolbar` : null,
          onClick: this.onClick,
          onKeyDown: this.onKeyDown,
          ref: this.handleToolbarRef,
          tabIndex: "0"
        };
        const ToolbarWrapper = this.ToolbarDecoration || "div";
        return /* @__PURE__ */ React.createElement(ToolbarWrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(ToolbarContent, __spreadValues({}, toolbarContentProps)), this.renderInlinePanel(), this.renderPanel());
      } else {
        return null;
      }
    }
  }, __publicField(_a, "propTypes", {
    hide: PropTypes.bool,
    removeToolbarFocus: PropTypes.func
  }), _a;
}

export { createAtomicPluginToolbar as default };
//# sourceMappingURL=createAtomicPluginToolbar.js.map
